import client from "./client";

export async function getPaymentConfig() {
  const res = await client.get("/payment/config");
  return res.data;
}

export async function confirmPayment({ paymentKey, orderId, amount }) {
  const res = await client.post("/payment/confirm", { paymentKey, orderId, amount });
  return res.data;
}

export async function failPayment(orderId) {
  const res = await client.post("/payment/fail", { orderId });
  return res.data;
}
